import { connect } from "@evertrue/et-flux";
import AllUsersStore from "apps/users/stores/all-users-store";
import { AdvancedCombobox } from "@evertrue/et-components";
import PropTypes from "prop-types";
import _ from "underscore";

const mapStateToProps = () => ({ users: AllUsersStore.getAllGivingTreeUsers() });

const UserSelector = ({ users, selected, onChange }) => {
  const user_arr = _.map(users, user => ({ value: user.id, label: user.name }));
  return (
    <div className="user-selector--box-wrapper">
      <AdvancedCombobox
        options={user_arr}
        grouped={false}
        searchable={true}
        value={selected}
        search_placeholder="Assign To-Do"
        placeholder="Select Assignee..."
        onChange={onChange}
      />
    </div>
  );
};

UserSelector.propTypes = {
  users: PropTypes.object,
  selected: PropTypes.object,
  onChange: PropTypes.func,
};

UserSelector.defaultProps = {
  users: {},
  selected: {},
  onChange: () => {},
};

export default connect(UserSelector, [AllUsersStore], mapStateToProps);
